import React from 'react'
import DocumentIcon from './icons/DocumentIcon'
import ChevronIcon from './icons/ChevronIcon'
import ApplicationStatus from './ApplicationStatus'
import { Link } from 'react-router-dom'
import TrashIcon from './icons/TrashIcon'
import { useDispatch, useSelector } from 'react-redux'
import { updateDocumentRequest } from '../../store/actions/documentRequestActions'

const DocumentRequest = ({document}) => {
    const dispatch = useDispatch()
    const documentRequestsSelector = useSelector(state => state.documentRequests)

    const cancelRequest = () => {
        if(window.confirm(`This document request for "${document.name}" will be cancelled and deleted. Are you sure you want to proceed?`)) {
            dispatch(updateDocumentRequest(document._id, {status: 'CANCELLED'}))
        }
    }

    return (
        <div className='w-full border border-dashed border-gray-300 rounded-[8px] p-2 flex items-center gap-x-1 transition duration-300 hover:shadow-lg relative'>
            {documentRequestsSelector.updatingDocumentRequest === document.id && <div className='absolute top-0 left-0 w-full h-[85px] bg-white bg-opacity-80 z-50 rounded-[8px]' />}
            <div className=' relative'>
                <DocumentIcon className={`w-10 h-10 text-gray-500`} />
            </div>
            <div className='w-full relative'>
                <p className='text-sm mb-1'>{document.name}</p>
                <p className='text-xs mb-1 text-gray-500'>Requested by: {document.requestedBy.name}</p>
                
                <div className='flex items-center justify-between'>
                    <ApplicationStatus status={document.status} />
                    {document.sampleDocumentUrl && <Link to={document.sampleDocumentUrl} target='_blank' className='text-gray-400 hover:text-vcm-purple transition duration-200 text-xs flex items-center gap-x-2'>Sample <ChevronIcon className={`w-4 h-4 rotate-180`} /></Link>}
                </div>

                {document.status === 'PENDING' && <button onClick={()=>{cancelRequest()}} className='absolute top-0 right-0 p-1 rounded bg-transparent mb-[10px] hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                    <TrashIcon className={`w-4 h-4`} />
                </button>}
            </div>
        </div>
    )
}

export default DocumentRequest